
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Location_$reflection, LocationDetailDto_$reflection } from "../../Shared/Location.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { union_type, string_type, class_type, record_type, bool_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(Location, Locations, IsDeleteDialogOpen, FormState) {
        super();
        this.Location = Location;
        this.Locations = Locations;
        this.IsDeleteDialogOpen = IsDeleteDialogOpen;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Location.Detail.Types.State", [], State, () => [["Location", RequestedValue$1_$reflection(LocationDetailDto_$reflection())], ["Locations", RequestedValue$1_$reflection(list_type(Location_$reflection()))], ["IsDeleteDialogOpen", bool_type], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OpenDeleteDialog", "CloseDeleteDialog", "DeleteLocation", "LocationFetched", "LocationsFetched", "FetchError", "LocationDeleted"];
    }
}

export function Msg_$reflection() {
    return union_type("Location.Detail.Types.Msg", [], Msg, () => [[], [], [], [["Item", LocationDetailDto_$reflection()]], [["Item", list_type(Location_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", ClientApiResponse$1_$reflection(string_type)]]]);
}

